import { render, staticRenderFns } from "./CouponUserDrawer.vue?vue&type=template&id=397a1416&scoped=true"
import script from "./CouponUserDrawer.vue?vue&type=script&lang=js"
export * from "./CouponUserDrawer.vue?vue&type=script&lang=js"
import style0 from "./CouponUserDrawer.vue?vue&type=style&index=0&id=397a1416&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a1416",
  null
  
)

export default component.exports